import { isRootLinkActive } from '../Sidebar';
export default function useActiveTab({ sidebarItems = [], defaultTab }) {
    var _a, _b, _c, _d;
    const activeApp = sidebarItems.find(({ path }) => isRootLinkActive(path));
    const activeAppExistsInMultipleTabs = ((_a = activeApp === null || activeApp === void 0 ? void 0 : activeApp.tabs) === null || _a === void 0 ? void 0 : _a.length) > 1;
    const getSessionStorage = (key) => {
        try {
            return sessionStorage.getItem(key);
        }
        catch (error) {
            return undefined;
        }
    };
    const activeTab = activeAppExistsInMultipleTabs
        ? (_b = getSessionStorage('lastActiveTab')) !== null && _b !== void 0 ? _b : defaultTab
        : (_d = (_c = activeApp === null || activeApp === void 0 ? void 0 : activeApp.tabs) === null || _c === void 0 ? void 0 : _c[0]) !== null && _d !== void 0 ? _d : defaultTab;
    const setLastActiveTab = (value) => sessionStorage.setItem('lastActiveTab', value);
    return {
        activeTab,
        setLastActiveTab
    };
}
